import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RedirectHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // 1. Получаем параметры из URL
    const params = new URLSearchParams(location.search);
    let target = params.get('goto');

    if (target) {
      // 2. Очистка и БЕЗОПАСНОСТЬ (Anti-Phishing & XSS)
      target = target.trim();

      // Нормализация: декодируем URL-кодированные символы для проверки
      // Это помогает обнаружить обфусцированные схемы, например javascript%3A -> javascript:
      let normalizedTarget = target;
      try {
        normalizedTarget = decodeURIComponent(target);
      } catch (e) {
        // Если декодирование не удалось, используем оригинал
      }

      // Удаляем пробельные символы для проверки (некоторые браузеры могут игнорировать пробелы в схемах)
      const cleanTarget = normalizedTarget.replace(/\s+/g, '').toLowerCase();

      // Проверяем, не пытается ли ссылка увести на другой домен или использовать опасные схемы.
      // - /^[a-z]+:/i ловит http:, https:, ftp:, javascript:, data: и т.д.
      // - target.startsWith('//') ловит protocol-relative URLs
      // - target.startsWith('\\') ловит пути с обратным слэшем (могут работать как //)
      const isDangerous = 
        /^[a-z]+:/i.test(target) || 
        /^[a-z]+:/i.test(normalizedTarget) ||
        /^[a-z]+:/i.test(cleanTarget) ||
        target.startsWith('//') || 
        target.startsWith('\\') ||
        normalizedTarget.startsWith('//') ||
        normalizedTarget.startsWith('\\');

      if (isDangerous) {
        console.warn('Blocked dangerous redirect attempt:', target);
        // Можно перенаправить на главную или показать 404
        window.location.assign('/'); 
        return;
      }

      // 3. Убеждаемся, что путь начинается со слэша
      if (!target.startsWith('/')) {
        target = '/' + target;
      }

      // 4. Выполняем редирект
      // window.location.assign (или .href) делает полную перезагрузку страницы,
      // что позволяет выйти из React-приложения (например, на /auth.html)
      window.location.assign(target);
    }
  }, [location]);

  return null; 
};

export default RedirectHandler;
